/** 一覧シートに並べるラリー 1 件のカード */

import { Stamp } from 'lucide-react'

import type { StampRallySummary } from '@/api/types/stamp-rally'
import { Badge } from '@/components/ui/badge'

import { isRallyComplete } from '../lib'

const DEFAULT_COLOR = '#F97316'

export const RallyCard = ({ rally, onClick }: { rally: StampRallySummary; onClick: () => void }) => {
  const percent = Math.round(rally.progress * 100)
  const isComplete = isRallyComplete(rally)
  const color = rally.color ?? DEFAULT_COLOR

  return (
    <button
      onClick={onClick}
      className="flex w-full flex-col gap-2 rounded-xl border bg-card p-4! text-left transition-colors hover:bg-accent/40"
    >
      <div className="flex items-center gap-2">
        <div
          className="flex size-9 shrink-0 items-center justify-center rounded-lg"
          style={{ backgroundColor: `${color}26` }}
        >
          <Stamp size={18} style={{ color }} />
        </div>
        <span className="min-w-0 flex-1 truncate font-medium">{rally.title}</span>
        {isComplete && <Badge className="shrink-0">コンプリート</Badge>}
      </div>

      <div className="flex items-baseline justify-between text-sm text-muted-foreground">
        <span className="tabular-nums">
          {rally.stamped_count} / {rally.total_count}
        </span>
        <span className="tabular-nums">{percent}%</span>
      </div>

      <div className="h-2 w-full overflow-hidden rounded-full bg-primary/15">
        <div className="h-full transition-all" style={{ width: `${percent}%`, backgroundColor: color }} />
      </div>
    </button>
  )
}
